import React, { useState, useEffect, useContext } from "react";
import { getAnalytics, setUserId } from "firebase/analytics";
import Container from "react-bootstrap/Container";
import { FormattedMessage, useIntl } from "react-intl";
import Image from "react-bootstrap/Image";
import {
  ConfigProvider,
  Tabs,
  Form,
  Input,
  Modal,
  Button,
  message,
  Carousel,
} from "antd";
import QuoteForm from "./components/quote";
import PlaceOrder from "./components/placeOrder";
import theme from "@/AntDesignConfig";

import Hmain from "@/components/h";

import italicTextLogo from "@/assets/italic_text_logo.png";

import { createStyles } from "antd-style";
import CardForm from "./components/CardForm";

import JSONBig from "json-bigint";
import { BASE_API_URL } from "@/network.config";
import qs from "qs";
import OrderSuccess from "./components/orderSuccess";
import { useSearchParams } from "react-router-dom";

import OrderList from "./components/OrderList";

import { glogEvent } from "@/components/firebaseConfig";

import { AppContext } from "@/Context";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Toast from "react-bootstrap/Toast";

import iconQRCode from "@/assets/ic_qrcode@2x.png";
import QrCodeImg from "@/assets/wechat-qr-new.png";
import contactIcon from "@/assets/contact-icon-new.png";

// Using existing assets
import serviceIcon1 from "@/assets/box_icon@3x.png";
import serviceIcon2 from "@/assets/pic_truck@2x.png";
import serviceIcon3 from "@/assets/pallet_icon@3x.png";
import serviceIcon4 from "@/assets/location_icon@3x.png";

// Stats icons - using existing icons
import statsIcon1 from "@/assets/ic_user@2x.png";
import statsIcon2 from "@/assets/ic_check@2x.png";
import statsIcon3 from "@/assets/Start@3x.png";
import statsIcon4 from "@/assets/timer_icon.png";

// Map images - using existing map assets
import mapTopImage from "@/assets/map_top.png";
import mapBottomImage from "@/assets/map_bottom.png";

// Carrier avatars - using existing assets
import carrierAvatar1 from "@/assets/ic_driver@2x.png";
import carrierAvatar2 from "@/assets/ic_driver_yellow@2x.png";
import carrierAvatar3 from "@/assets/shipper_black@2x.png";

// Mobile app image - using existing phone image
import mobileAppImage from "@/assets/pic_phone@3x.png";

const useStyle = createStyles(({ prefixCls, css }) => ({
  linearGradientButton: css`
    &.${prefixCls}-btn-primary:not([disabled]):not(
        .${prefixCls}-btn-dangerous
      ) {
      border-width: 0;

      > span {
        position: relative;
        font-size: 17px;
        font-weight: 600;
      }

      &::before {
        content: "";
        background: linear-gradient(166deg, #ea7e30 0%, #f5be51 100%);
        position: absolute;
        inset: 0;
        opacity: 1;
        transition: all 0.3s;
        border-radius: inherit;
      }

      &:hover::before {
        opacity: 0;
      }
    }
  `,
}));

const useCountDown = (s) => {
  const [seconds, setSeconds] = useState(s);
  useEffect(() => {
    setTimeout(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);
  }, [seconds]);

  return [seconds, setSeconds];
};

export default function Quote() {
  const { onShipperLogin } = useContext(AppContext);

  const [searchParams] = useSearchParams();
  const { styles } = useStyle();

  const [messageApi, contextHolder] = message.useMessage();

  const [finalOrderData, setFinalOrderData] = useState(null);

  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [loginForm] = Form.useForm();
  const [smsCount, setSMSCount] = useCountDown(0);
  const [isSMSLoading, setIsSMSLoading] = useState(false);

  const [shipperToken, setShipperToken] = useState(null);
  const [tab, setTab] = useState("1");

  const [tabBadge, setTabBadge] = useState({});

  const [orderSuccess, setOrderSuccess] = useState(false);

  const [showTopQRDownloadToast, setShowTopQRDownloadToast] = useState(false);
  const [showShipperQRDownloadToast, setShowShipperQRDownloadToast] = useState(false);
  const [showCarrierQRDownloadToast, setShowCarrierQRDownloadToast] = useState(false);

  // 订单数据 未支付
  const [orderId, setOrderId] = useState(undefined);

  const [quoteData, setQuoteData] = useState({});

  const [orderList, setOrderList] = useState([]);
  const [orderListLoading, setOrderListLoading] = useState(false);
  
  // Check if we're on mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    // get token form local storage using key : "shipper_token"
    let token = localStorage.getItem("shipper_token");
    if (token) {
      setShipperToken(token);
      getTabBadge().then((badge) => {
        setTabBadge(badge);
      });
    } else {
      if (searchParams.get("modal") === "1") {
        setTimeout(() => {
          setIsLoginModalOpen(true);
          // remove modal param
          window.history.replaceState(
            {},
            document.title,
            window.location.pathname
          );
        }, 1000);
      }
    }
  }, []);

  const goToOrderList = () => {
    setTab("0");
  };

  const fetchOrderList = async (tab) => {
    setOrderListLoading(true);

    // param tab 0-我的发布，1-运单消息，2-运输中，3-已完成
    let payload = {
      tab: tab,
    };
    let params = {
      page_num: 1,
      page_size: 100,
      tab: tab,
    };
    let token = localStorage.getItem("shipper_token");
    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const response = await fetch(
      `${BASE_API_URL}/api/v1/app/shipper/orders?${qs.stringify(params)}`,
      {
        method: "POST",
        body: JSON.stringify(payload),
        headers: headers,
      }
    );
    if (response.status === 401) {
      setIsLoginModalOpen(true);
      setOrderListLoading(false);
      return;
    }
    if (!response.ok) {
      setOrderListLoading(false);
      return;
    }
    const text = await response.text();
    const result = JSONBig({ storeAsString: true }).parse(text);
    setOrderList(result.data.data);
    setOrderListLoading(false);
  };

  const deleteOrder = async (orderId) => {
    console.log("deleteOrder", orderId);
    let token = localStorage.getItem("shipper_token");
    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const response = await fetch(
      `${BASE_API_URL}/api/v1/app/shipper/orders/${orderId}`,
      {
        method: "DELETE",
        headers: headers,
      }
    );
    if (response.status === 401) {
      setIsLoginModalOpen(true);
      return;
    }
    if (!response.ok) {
      messageApi.error("Delete order failed");
      return;
    }
    messageApi.success("订单删除成功");
    await fetchOrderList(tab);
  };

  useEffect(() => {
    if (tab !== "1") {
      fetchOrderList(tab);
    }
  }, [tab]);

  const goToQuote = () => {
    setPlaceOrderShow(false);
    setOrderSuccess(false);
    setOrderId(undefined);
    setTab("1");
  };

  const login = async (params) => {
    const payload = {
      tel: params.phone,
      country_code: "+1",
      code: params.password,
      role: 0,

    };
    try {
      const response = await fetch(`${BASE_API_URL}/api/v1/app/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      if (result.code !== 0) {
        console.error(`Login failed: ${result.errmsg}`);
        messageApi.error(result.errmsg);
        return null;
      }
      const { access_token, user_id, current_role, is_verify } = result.data;
      const analytics = getAnalytics();
      setUserId(analytics, params.phone);
      setShipperToken(access_token)
      onShipperLogin(access_token, params.phone);

      setIsLoginModalOpen(false);

      return access_token;
    } catch (error) {
      console.error("Login error:", error);
      messageApi.error("Login failed. Please try again.");
      return null;
    }
  };

  const fetchCode = async (params) => {
    try {
      setIsSMSLoading(true);
      const response = await fetch(`${BASE_API_URL}/api/v1/app/sendsms`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      });

      if (response.status !== 200) {
        console.log(`request login send code api failed:${response.status}`);
        messageApi.error("网络错误");
        return;
      }
      setSMSCount(60);
    } catch (error) {
      console.log(`request login api error: ${error}`);
      messageApi.error("网络错误");
    } finally {
      setIsSMSLoading(false);
    }
  };

  const getTabBadge = async () => {
    try {
      const token = localStorage.getItem("shipper_token");
      if (!token) {
        return;
      }
      const response = await fetch(
        `${BASE_API_URL}/api/v1/app/unread/message/badge`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 401) {
        localStorage.removeItem("shipper_token");
        setShipperToken(null);
        return;
      }
      const text = await response.text();
      const result = JSONBig({ storeAsString: true }).parse(text);
      console.log("getTabBadge result", result);
    } catch (error) {
      console.log(`get badge api error: ${error.message}`);
    }
  };
  const placeOrder = async (data) => {
    try {
      // Google analytics custom event log
      glogEvent("shipper_submit", data);

      const response = await fetch(
        `${BASE_API_URL}/api/v1/app/shipper/order/submit`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${shipperToken}`,
          },
          body: JSON.stringify(data),
        }
      );
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const text = await response.text();
      const result = JSONBig({ storeAsString: true }).parse(text);
      console.log("place order result", result);
      if (result.code !== 0) {
        console.log(`place order api failed:${JSON.stringify(result)}`);
        messageApi.error(result.errmsg);
        return;
      }
      console.log("place order result", result);
      setOrderId(result.data.order_id);
      setFinalOrderData(data);
    } catch (error) {
      console.log(`place order api error: ${error.message}`);
      messageApi.error("网络错误");
    }
  };

  const getOrderDetail = async (orderId) => {
    // 订单详情
    // /api/v1/app/shipper/orders/{order_id}
    const response = await fetch(
      `${BASE_API_URL}/api/v1/app/shipper/orders/${orderId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${shipperToken}`,
        },
      }
    );
    const text = await response.text();
    const result = JSONBig({ storeAsString: true }).parse(text);
    console.log("getOrderDetail result", result);
    setFinalOrderData(result.data);
  };

  const continuePay = (orderId) => {
    console.log("continuePay", orderId);
    // 订单列表 未支付订单 支付
    setOrderId(orderId);
    getOrderDetail(orderId);
    setOrderSuccess(false);
    setTab("1");
  };
  

  // payment
  const pay = async (data) => {
    console.log("pay", data);
    let payload = {
      order_id: orderId,
      card_id: data.card_id,
      billing_address: data.billing_address
        ? data.billing_address
        : {
            name: finalOrderData.pickup_address.name,
            address_line1: finalOrderData.pickup_address.address_line1,
            address_line2: finalOrderData.pickup_address.address_line2,
            city: finalOrderData.pickup_address.city,
            state: finalOrderData.pickup_address.state,
            zipcode: finalOrderData.pickup_address.zipcode,
          },
    };

    // Google analytics custom event log
    glogEvent("shipper_pay", payload);

    try {
      const response = await fetch(
        `${BASE_API_URL}/api/v1/app/shipper/order/payment/v2`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${shipperToken}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(response.statusText);
      }

      const text = await response.text();
      const result = JSONBig({ storeAsString: true }).parse(text);

      if (result.code !== 0) {
        console.log(`payment api failed: ${JSON.stringify(result)}`);
        messageApi.error(result.errmsg);
        return;
      }
      console.log("payment result", result);
      setOrderSuccess(true);
    } catch (error) {
      console.log(`payment api error: ${error.message}`);
      messageApi.error("网络错误");
    }
  };

  const onTabChange = (key) => {
    if (["0", "2", "3"].includes(key)) {
      if (!shipperToken) {
        setIsLoginModalOpen(true);
        return;
      }
    }
    setTab(key);
  };

  const tabItems = [
    {
      key: "1",
      label: useIntl().formatMessage({
        id: "page.quote.tab.offer",
        description: "在线下单",
      }),
    },
    {
      key: "0",
      label: useIntl().formatMessage({
        id: "page.quote.tab.published",
        description: "已发布",
      }),
    },
    {
      key: "2",
      label: useIntl().formatMessage({
        id: "page.quote.tab.in.transit",
        description: "运输中",
      }),
    },
    {
      key: "3",
      label: useIntl().formatMessage({
        id: "page.quote.tab.done",
        description: "已完成",
      }),
    },
  ];

  const [placeOrderShow, setPlaceOrderShow] = useState(false);
  const [isPallet, setIsPallet] = useState(false);
  const gotoPlaceOrder = (gotQuoteData) => {
    setQuoteData(gotQuoteData);
    setIsPallet(gotQuoteData.is_pallet);
    console.log("shipperToken", shipperToken);
    if (!shipperToken) {
      setIsLoginModalOpen(true);
      return;
    }
    setPlaceOrderShow(true);
  };



  return (
    <ConfigProvider
      theme={theme}
      button={{
        className: styles.linearGradientButton,
      }}
    >
      {contextHolder}
      
      {/* Hero Section - Exact Figma Match */}
      <section 
        className="flex items-center justify-center"
        style={{
          width: '100%',
          maxWidth: '1440px',
          backgroundImage: `url(${require('@/assets/hero-background-new-3cdf6f.png')})`,
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat',
          padding: isMobile ? '24px 16px' : '24px 160px',
          margin: '0 auto'
        }}
      >
        <div 
          className="flex flex-col justify-end w-full"
          style={{
            maxWidth: '1120px',
            gap: '16px'
          }}
        >
          {/* Text Group */}
          <div 
            className="flex flex-col"
            style={{
              gap: '10px',
              padding: '10px 0px',
              width: 'fit-content'
            }}
          >
            <h1 
              className="text-white"
              style={{
                fontFamily: 'PingFang SC',
                fontWeight: 600,
                fontSize: isMobile ? '24px' : '40px',
                lineHeight: '1.4em',
                margin: 0
              }}
            >
              专为在美华人商户打造
            </h1>
            <h2 
              className="text-white"
              style={{
                fontFamily: 'PingFang SC',
                fontWeight: 600,
                fontSize: isMobile ? '24px' : '40px',
                lineHeight: '1.4em',
                margin: 0
              }}
            >
              拼货物流平台
            </h2>
          </div>

          {/* Button Section */}
          <div 
            className="flex"
            style={{
              gap: '24px',
              width: isMobile ? '100%' : '464px',
              maxWidth: '464px'
            }}
          >
            <div className="flex">
              {/* Download Button */}
              <div
                className="flex items-center justify-center bg-[#2769CD] text-white cursor-pointer"
                style={{
                  width: '160px',
                  height: '60px',
                  padding: '15px 43px',
                  borderRadius: '8px 0px 0px 8px',
                  fontFamily: 'PingFang SC',
                  fontWeight: 600,
                  fontSize: '17px',
                  lineHeight: '1.4em',
                  textAlign: 'center'
                }}
              >
                APP下载
              </div>
              
              {/* QR Code Button */}
              <div 
                className="relative cursor-pointer"
                style={{
                  width: '60px',
                  height: '60px'
                }}
                onClick={() => setShowTopQRDownloadToast(true)}
              >
                <div 
                  className="absolute bg-[#2769CD]"
                  style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '0px 8px 8px 0px'
                  }}
                />
                <div 
                  className="absolute bg-white opacity-20"
                  style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '0px 8px 8px 0px'
                  }}
                />
                <div 
                  className="absolute flex items-center justify-center"
                  style={{
                    width: '24px',
                    height: '24px',
                    top: '18px',
                    left: '18px'
                  }}
                >
                  <img src={iconQRCode} alt="QR Code" className="w-6 h-6 relative z-10 brightness-0 invert" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Section - Exact Figma Frame 12315 Match */}
      <section className="bg-[#F1F1F1] flex flex-col items-center">
        <div 
          className="flex flex-col items-end"
          style={{
            width: '1120px',
            gap: '56px',
            padding: '48px 0px'
          }}
        >
          {/* Title Section - Frame 12299 */}
          <div 
            className="flex flex-col self-stretch"
            style={{ gap: '32px' }}
          >
            <div 
              className="flex flex-col items-center"
              style={{
                width: '1121px',
                gap: '16px'
              }}
            >
              <h1 
                style={{
                  fontFamily: 'PingFang SC',
                  fontWeight: 400,
                  fontSize: '32px',
                  lineHeight: '1.4em',
                  color: '#000000',
                  margin: 0
                }}
              >
                {orderSuccess ? "订单成功" : orderId !== undefined ? "支付订单" : "免费估价"}
              </h1>
              <p 
                style={{
                  fontFamily: 'PingFang SC',
                  fontWeight: 600,
                  fontSize: '17px',
                  lineHeight: '1.4em',
                  color: '#000000',
                  margin: 0,
                  textAlign: 'center'
                }}
              >
                {orderSuccess 
                  ? "您的订单已成功提交，我们会尽快为您安排运输服务"
                  : orderId !== undefined 
                    ? "请完成支付以确认您的订单"
                    : "无需注册，三十秒钟即可体验完整报价流程"
                }
              </p>
            </div>

            {/* Tab Navigation */}
            <div className="w-full">
              <Tabs
                activeKey={tab}
                items={tabItems}
                onChange={onTabChange}
                size={isMobile ? "small" : "default"}
                centered
                className="custom-tabs"
              />
            </div>

            {/* Form Container - Frame 12582 */}
            <div 
              className="flex flex-col self-stretch"
              style={{ gap: '24px' }}
            >
            
            {/* Quote Tab */}
            {tab === "1" && (
              <>
                {orderSuccess ? (
                  <div 
                    className="bg-white flex flex-col self-stretch gap-6 rounded-2xl"
                    style={{
                      backgroundColor: '#FFFFFF',
                      borderRadius: '16px',
                      padding: '40px'
                    }}
                  >
                    <OrderSuccess
                      orderId={orderId}
                      goToOrderList={goToOrderList}
                      goToQuote={goToQuote}
                    />
                  </div>
                ) : orderId === undefined ? (
                  <div 
                    className="bg-white flex flex-col self-stretch gap-6 rounded-2xl"
                    style={{
                      backgroundColor: '#FFFFFF',
                      borderRadius: '16px',
                      padding: '40px'
                    }}
                  >
                    {!placeOrderShow ? (
                      <QuoteForm nextStep={gotoPlaceOrder} />
                    ) : (
                      <PlaceOrder
                        quoteData={quoteData}
                        goToQuote={goToQuote}
                        placeOrder={placeOrder}
                      />
                    )}
                  </div>
                ) : (
                  <div 
                    className="bg-white flex flex-col self-stretch gap-6 rounded-2xl"
                    style={{
                      backgroundColor: '#FFFFFF', 
                      borderRadius: '16px',
                      padding: '40px'
                    }}
                  >
                    <CardForm pay={pay} />
                  </div>
                )}
              </>
            )}

            {/* Other Tabs */}
            {["0", "2", "3"].includes(tab) && (
              <>
                <div 
                  className="bg-white flex flex-col self-stretch gap-6 rounded-2xl"
                  style={{
                    backgroundColor: '#FFFFFF',
                    borderRadius: '16px', 
                    padding: '40px'
                  }}
                >
                  <OrderList
                    loading={orderListLoading}
                    orderList={orderList}
                    goToQuote={goToQuote}
                    deleteOrder={deleteOrder}
                    continuePay={continuePay}
                  />
                </div>
              </>
            )}

            </div>
          </div>

          {/* Bottom Button Section - Frame 12302 */}
          <div 
            className="flex items-end"
            style={{
              gap: '40px'
            }}
          >
            <div 
              className="flex items-center cursor-pointer"
              style={{
                gap: '10px',
                padding: '16px 80px',
                height: '60px',
                position: 'relative'
              }}
            >
              <div 
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '194px',
                  height: '60px',
                  backgroundColor: '#CECAC4',
                  borderRadius: '8px'
                }}
              />
              <span 
                style={{
                  fontFamily: 'PingFang SC',
                  fontWeight: 600,
                  fontSize: '17px',
                  lineHeight: '1.4em',
                  textAlign: 'center',
                  color: '#000000',
                  position: 'relative',
                  zIndex: 1
                }}
              >
                估价
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="bg-gray-600">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-8 lg:py-16">
          <div className="lg:flex lg:items-center lg:justify-between">
            {/* Contact Info */}
            <div className="lg:w-1/2">
              <div className="flex items-center gap-4 mb-6">
                <img
                  src={contactIcon}
                  alt="Contact"
                  className="w-9 h-9"
                />
                <h2 className="text-white text-2xl font-normal">联系我们</h2>
              </div>

              <p className="text-white text-sm lg:text-base mb-6 leading-relaxed">
                请扫描二维码添加微信客服，专业客服在线支持；也可以加入华人物流交流群参与讨论。等您参与，我们期待您的到来！
              </p>

              <button className="bg-brand-blue text-white px-8 py-3 rounded-lg text-base font-semibold mb-6">
                邮件沟通
              </button>
            </div>

            {/* WeChat QR */}
            <div className="lg:w-1/2 lg:flex lg:justify-end">
              <div className="text-center">
                <img
                  src={QrCodeImg}
                  alt="WeChat QR Code"
                  className="w-[100px] h-[100px] lg:w-[116px] lg:h-[116px] mx-auto mb-4 rounded-lg shadow-lg cursor-pointer hover:opacity-80 transition-opacity"
                  onClick={() => setShowShipperQRDownloadToast(true)}
                />
                <p className="text-white text-sm lg:text-base">添加微信客服</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Login Modal */}
      <Modal
        open={isLoginModalOpen}
        onCancel={() => {
          setIsLoginModalOpen(false);
        }}
        centered
        footer={null}
        width={720}
      >
        <div className="p-6">
          <Form
            name="login"
            layout="vertical"
            variant="filled"
            requiredMark={false}
            form={loginForm}
            onFinish={login}
          >
            <div className="text-center mb-8">
              <Image
                src={italicTextLogo}
                className="mx-auto mb-8"
                style={{ maxWidth: '200px' }}
              />
            </div>
            <Form.Item
              className="mb-4"
              name="phone"
              label={
                <span className="text-black text-sm font-normal">
                  {useIntl().formatMessage({
                    id: "page.quote.login.form.label.phone",
                    description: "电话号码",
                  })}
                </span>
              }
              rules={[
                {
                  required: true,
                  message: useIntl().formatMessage({
                    id: "page.quote.login.form.error.info.phone",
                    description: "电话号码 异常提示",
                  }),
                },
              ]}
            >
              <Input
                placeholder={useIntl().formatMessage({
                  id: "page.quote.login.form.placeholder.phone",
                  description: "电话号码 输入占位",
                })}
                size="large"
                className="rounded-lg"
                suffix={
                  <Button
                    type="link"
                    onClick={() => {
                      loginForm.validateFields(["phone"]).then((values) => {
                        console.log(values);
                        if (!isSMSLoading && smsCount === 0) {
                          fetchCode({ country_code: "+1", tel: values.phone });
                        }
                      });
                    }}
                    loading={isSMSLoading}
                    disabled={smsCount !== 0}
                    className="text-blue-600"
                  >
                    {smsCount > 0
                      ? `${smsCount}s`
                      : useIntl().formatMessage({
                          id: "page.quote.login.form.button.code",
                          description: "发送验证码 按钮 文案",
                        })}
                  </Button>
                }
              />
            </Form.Item>
            <Form.Item
              className="mb-6"
              name="password"
              label={
                <span className="text-black text-sm font-normal">
                  {useIntl().formatMessage({
                    id: "page.quote.login.form.label.code",
                    description: "验证码",
                  })}
                </span>
              }
              rules={[
                {
                  required: true,
                  message: useIntl().formatMessage({
                    id: "page.quote.login.form.error.info.code",
                    description: "验证码 异常提示",
                  }),
                },
              ]}
            >
              <Input
                placeholder={useIntl().formatMessage({
                  id: "page.quote.login.form.placeholder.code",
                  description: "验证码 输入占位",
                })}
                size="large"
                className="rounded-lg"
              />
            </Form.Item>
            <Form.Item>
              <Button 
                block 
                type="primary" 
                htmlType="submit" 
                size="large"
                className="rounded-lg h-12 text-lg font-semibold"
              >
                {useIntl().formatMessage({
                  id: "page.quote.login.form.button.login",
                  description: "登录 按钮 文案",
                })}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal>

      {/* Toast Messages */}
      <div className="fixed top-4 right-4 z-50 space-y-2">
        {showTopQRDownloadToast && (
          <Toast
            show={showTopQRDownloadToast}
            onClose={() => setShowTopQRDownloadToast(false)}
            delay={3000}
            autohide
          >
            <Toast.Header>
              <strong className="me-auto">二维码下载</strong>
            </Toast.Header>
            <Toast.Body>
              <div className="text-center">
                <img src={QrCodeImg} alt="QR Code" className="w-24 h-24 mx-auto mb-2 rounded-lg" />
                <p className="text-sm">扫描二维码下载APP</p>
              </div>
            </Toast.Body>
          </Toast>
        )}

        {showShipperQRDownloadToast && (
          <Toast
            show={showShipperQRDownloadToast}
            onClose={() => setShowShipperQRDownloadToast(false)}
            delay={3000}
            autohide
          >
            <Toast.Header>
              <strong className="me-auto">微信客服</strong>
            </Toast.Header>
            <Toast.Body>
              <div className="text-center">
                <img src={QrCodeImg} alt="QR Code" className="w-24 h-24 mx-auto mb-2 rounded-lg" />
                <p className="text-sm">扫描二维码添加微信客服</p>
              </div>
            </Toast.Body>
          </Toast>
        )}

        {showCarrierQRDownloadToast && (
          <Toast
            show={showCarrierQRDownloadToast}
            onClose={() => setShowCarrierQRDownloadToast(false)}
            delay={3000}
            autohide
          >
            <Toast.Header>
              <strong className="me-auto">承运人二维码</strong>
            </Toast.Header>
            <Toast.Body>
              <div className="text-center">
                <img src={QrCodeImg} alt="QR Code" className="w-24 h-24 mx-auto mb-2 rounded-lg" />
                <p className="text-sm">扫描二维码添加承运人微信</p>
              </div>
            </Toast.Body>
          </Toast>
        )}
      </div>

    </ConfigProvider>
  );
}
